"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PLAYSTATION_VERSION_REGEX = /PlayStation ([0-9]+)/;
var WebMafInfo = (function () {
    function WebMafInfo(webMafBridge) {
        this.webMafBridge = webMafBridge;
    }
    WebMafInfo.prototype.initialise = function () {
        this.initialiseProperties();
        return this.initialiseHardwareId();
    };
    WebMafInfo.prototype.initialiseProperties = function () {
        var playstationVersion = this.calculatePlaystationVersion();
        this.deviceType = 'Console';
        this.deviceVersion = playstationVersion;
        this.browserName = 'WebMAF';
        this.deviceManufacturer = 'Sony';
        this.deviceBrand = 'PlayStation';
        this.deviceModel = "PS" + playstationVersion;
        this.userFriendlyName = this.deviceModel;
        this.operatingSystemName = playstationVersion === '3' ? 'CellOS' : 'Orbis OS';
        this.browserVersion = this.webMafBridge.getDevSettings().version;
    };
    WebMafInfo.prototype.initialiseHardwareId = function () {
        var _this = this;
        return new Promise(function (resolve) {
            _this.webMafBridge.listenToEvent('hwid', function (data) {
                _this.uniqueDeviceId = data.hwid;
                resolve();
            }, true);
            _this.webMafBridge.sendCommand('hwid');
        });
    };
    WebMafInfo.prototype.calculatePlaystationVersion = function () {
        var playstationVersion = window.navigator.userAgent.match(PLAYSTATION_VERSION_REGEX);
        if (playstationVersion && playstationVersion.length > 1) {
            return playstationVersion[1];
        }
        else {
            return '3';
        }
    };
    return WebMafInfo;
}());
exports.WebMafInfo = WebMafInfo;
